import * as THREE from "three";
import type { RendererService } from "./RendererService";

export class SceneContext {
  readonly scene: THREE.Scene;
  readonly camera: THREE.PerspectiveCamera;
  readonly worldGroup: THREE.Group;
  // Exposed so game-side theming (palette per level) can mutate light
  // color / intensity without going through a private accessor. The
  // engine never reads these fields after construction.
  readonly ambient: THREE.AmbientLight;
  readonly keyLight: THREE.DirectionalLight;

  constructor(renderer: RendererService) {
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(0x06070b);
    this.scene.fog = new THREE.Fog(0x06070b, 25, 90);

    const size = renderer.getSize();
    const aspect = size.width / size.height;
    this.camera = new THREE.PerspectiveCamera(75, aspect, 0.1, 200);
    this.camera.position.set(0, 0, 6);
    this.camera.lookAt(0, 0, 0);

    this.worldGroup = new THREE.Group();
    this.worldGroup.name = "worldGroup";
    this.scene.add(this.worldGroup);

    this.ambient = new THREE.AmbientLight(0xffffff, 0.6);
    this.keyLight = new THREE.DirectionalLight(0xffffff, 0.4);
    this.keyLight.position.set(2, 4, 5);
    this.scene.add(this.ambient, this.keyLight);

    renderer.onResize.on(({ width, height }) => {
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    });
  }

  dispose(): void {
    this.scene.traverse((obj) => {
      const mesh = obj as THREE.Mesh;
      if (mesh.geometry) mesh.geometry.dispose?.();
      const mat = mesh.material as THREE.Material | THREE.Material[] | undefined;
      if (Array.isArray(mat)) mat.forEach((m) => m.dispose?.());
      else mat?.dispose?.();
    });
    this.scene.clear();
  }
}
